import { useTranslation } from 'react-i18next'
import { FormPageActions } from '@/shared/ui/form-page-actions'
import { PageHeader } from '@/shared/ui/page-header'

interface FormHeaderProps {
  isEdit: boolean
  /** Viewing an existing destination without the right to change it. */
  isReadonly: boolean
  listPath: string
  isSaving: boolean
  onBack: () => void
  onSubmit: () => void
}

/** Page title and breadcrumbs of the destination form. */
export function FormHeader({
  isEdit,
  isReadonly,
  listPath,
  isSaving,
  onBack,
  onSubmit,
}: FormHeaderProps) {
  const { t } = useTranslation()
  const title = isReadonly
    ? t('common.detail', { defaultValue: 'Detail' })
    : isEdit
      ? t('common.edit')
      : t('common.create')

  return (
    <PageHeader
      title={title}
      breadcrumbs={[
        {
          label: t('sidebar.destinations', { defaultValue: 'Destinations' }),
          path: listPath,
        },
        { label: title },
      ]}
      actions={
        <FormPageActions
          isEdit={isEdit}
          isSaving={isSaving}
          canSubmit
          onBack={onBack}
          onSubmit={onSubmit}
        />
      }
    />
  )
}
